import { getCustomComponent } from "@/utils/custom-components.utils";
import { useBrandConfig } from "@/utils/useBrandConfig";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";

const Layout = () => {
    const { name } = useBrandConfig();

    const Footer = getCustomComponent({
        brandName: name,
        folder: 'Footer',
    });

    return (
        <div className="flex flex-col h-dvh">
            <div className="flex-1">
                <Outlet />
            </div>
            <Suspense>
                <Footer />
            </Suspense>
        </div>
    )
}

export default Layout;
